module.exports = __webpack_public_path__ + "d9ef2bad9939bfcc2ebf94c37bf5e249.png";